import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        
        <h1 className="text-3xl md:text-4xl font-bold mb-4" data-testid="cancel-title">
          Pago Cancelado
        </h1>
        
        <p className="text-lg text-zinc-400 mb-8">
          Tu pago ha sido cancelado. No se ha realizado ningún cargo a tu cuenta.
        </p>
        
        <div className="space-y-4">
          <p className="text-sm text-zinc-600">
            Si tienes alguna pregunta, no dudes en contactarnos.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="bg-white text-black hover:bg-zinc-200 rounded-none px-8 py-4 text-sm font-bold tracking-widest uppercase" data-testid="back-home-btn">
                Volver al Inicio
              </Button>
            </Link>
            
            <Link to="/#precios">
              <Button variant="outline" className="border-white/20 hover:bg-white hover:text-black rounded-none px-8 py-4 text-sm font-bold tracking-widest uppercase" data-testid="retry-btn">
                Intentar de Nuevo
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
